import React, { useEffect } from "react";
import Logo from "../../assets/images/dashboardLogo.svg";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { RxDashboard } from "react-icons/rx";
import { TbUsers } from "react-icons/tb";
import { BsFolder2Open } from "react-icons/bs";
import { GoBell } from "react-icons/go";
import { CiEdit } from "react-icons/ci";
import { LuSettings } from "react-icons/lu";
import { IoMdLogOut } from "react-icons/io";
import { Chip, Collapse, Divider, List, ListItemButton, Box, Stack } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import Bus from "../../event/bus";
import LogoutModal from "../Dashboard/Modals/LogoutModal";
import { useNavigate } from "react-router-dom";
import { listItemButtonStyle, navLinkStyle } from "../Dashboard/Tables/Styles";

const Sidebar = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mobile, setMobile] = useState(false);

  const removeSidebar = () => {
    setSidebarOpen(false);
    setMobile(false);
  };

  const [open, setOpen] = React.useState(false);
  const [openHr, setOpenHr] = React.useState(false);
  const [openLogout, setOpenLogout] = React.useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleCustomEvent = () => {
      setMobile(!mobile);
      setSidebarOpen(!sidebarOpen);
    };

    Bus.on("toggle-sidebar", handleCustomEvent);

    return () => {
      Bus.off("toggle-sidebar", handleCustomEvent);
    };
  }, [mobile, sidebarOpen]);

  const handleClick = () => {
    setOpen(!open);
  };

  const handleHrClick = () => {
    setOpenHr(!openHr);
  };

  const handleOpenLogout = (e) => {
    setOpenLogout(true);
  };

  const handleCloseLogout = () => {
    setOpenLogout(false);
  };

  const handleActionLogout = () => {
    setOpenLogout(false);
    setTimeout(() => {
      navigate("/auth/login");
    }, 500);
  };

  return (
    <div>
      {mobile && (
        <div
          className="absolute inset-0 z-50  backdrop-blur-sm"
          onClick={removeSidebar}
        ></div>
      )}
      <div
        className={`${sidebarOpen ? "w-40 z-50 absolute transition-width" : "hidden z-10"
          } h-screen sm:block min-w-[17rem] bg-[#fff] text-white overflow-y-hidden`}
      >
        <div
          className="flex flex-col h-screen overflow-y-auto justify-between pt-6 p-6 mt-1 "
          id="sidebar"
        >
          <nav className="flex flex-col justify-between h-[100vh]">

            <ul>
              <li className="mb-12">
                <NavLink

                  to="/dashboard"
                  className="flex  gap-4 items-center hover:text-[#1E87FF] !font-sans text-sm leading-4 text-[#292727] font-bold"
                >
                  <img src={Logo} alt="Logo" />
                </NavLink>
              </li>
              <li className="mb-4">
                <NavLink
                  style={navLinkStyle}
                  to="/dashboard"
                  className="flex gap-4 items-center  hover:text-[#1E87FF]   hover:font-bold "
                >
                  <RxDashboard className="sidebar-icon" />
                  <span>Dashboard</span>
                </NavLink>
              </li>
              <li className="mb-4">
                <List>
                  <Box
                    onClick={handleClick}
                    sx={{
                      ":hover": {
                        fontWeight: 700,
                        color: '#1E87FF !important'
                      }
                    }}
                    className="flex gap-4 items-center justify-between !text-[#292727]  !font-sans text-sm leading-4 font-normal cursor-pointer"
                  >
                    <Stack spacing={2} direction='row' >
                      <TbUsers />
                      <span className="mr-16 ">On-Boarding </span>
                    </Stack>

                    {open ? <ExpandLess /> : <ExpandMore />}
                  </Box>
                  <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <NavLink
                        style={navLinkStyle}
                        to="/dashboard/applicants"
                        className="flex gap-4 items-center !hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-normal"
                      >
                        <ListItemButton sx={listItemButtonStyle}>
                          <span>Applicants</span>
                        </ListItemButton>
                      </NavLink>
                      <NavLink
                        style={navLinkStyle}
                        to="/dashboard/interviews"
                        className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                      >
                        <ListItemButton sx={listItemButtonStyle}>
                          <span>Interview</span>
                        </ListItemButton>
                      </NavLink>
                      <NavLink
                        style={navLinkStyle}
                        to="/dashboard/offers"
                        className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                      >
                        <ListItemButton sx={listItemButtonStyle}>
                          <span>Offer</span>
                        </ListItemButton>
                      </NavLink>
                      <NavLink
                        style={navLinkStyle}
                        to="/dashboard/onboarding/tracker"
                        className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                      >
                        <ListItemButton sx={listItemButtonStyle}>
                          <span>OnBoarding Tracker</span>
                        </ListItemButton>
                      </NavLink>
                      <NavLink
                        style={navLinkStyle}
                        to="/dashboard/onboarding/process"
                        className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                      >
                        <ListItemButton sx={listItemButtonStyle}>
                          <span>OnBoarding Process</span>
                        </ListItemButton>
                      </NavLink>
                      <NavLink
                        style={navLinkStyle}
                        to="/dashboard/onboarding/orientation"
                        className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                      >
                        <ListItemButton sx={listItemButtonStyle}>
                          <span>Orientation Topics</span>
                        </ListItemButton>
                      </NavLink>
                    </List>
                  </Collapse>
                </List>
              </li>

              <li className="mb-4">
                <List>
                  <Box
                    onClick={handleHrClick}
                    sx={{
                      ":hover": {
                        fontWeight: 700,
                        color: '#1E87FF !important'
                      }
                    }}
                    className="flex gap-4 items-center justify-between !text-[#292727] !font-sans text-sm leading-4 font-normal cursor-pointer"
                  >
                    <Stack spacing={2} direction='row' >
                      <BsFolder2Open className="sidebar-icon" />
                      <span >Employee HR Files </span>
                    </Stack>

                    {openHr ? <ExpandLess /> : <ExpandMore />}
                  </Box>
                  <Collapse in={openHr} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      <NavLink
                        style={navLinkStyle}
                        to="/dashboard/hr/employees"
                        className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                      >
                        <ListItemButton sx={listItemButtonStyle}>
                          <span>Employees</span>
                        </ListItemButton>
                      </NavLink>
                      <NavLink
                        style={navLinkStyle}
                        to="/dashboard/hr/eval-assessment"
                        className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                      >
                        <ListItemButton sx={listItemButtonStyle}>
                          <span>Eval / Assessment</span>
                        </ListItemButton>
                      </NavLink>
                      <NavLink
                        style={navLinkStyle}
                        to="/dashboard/hr/quarterly-training"
                        className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                      >
                        <ListItemButton sx={listItemButtonStyle}>
                          <span>Quarterly Training</span>
                        </ListItemButton>
                      </NavLink>
                      <NavLink
                        style={navLinkStyle}
                        to="/dashboard/hr/termination"
                        className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                      >
                        <ListItemButton sx={listItemButtonStyle}>
                          <span>Termination</span>
                        </ListItemButton>
                      </NavLink>
                    </List>
                  </Collapse>
                </List>
              </li>

              <li className="mb-8">
                <NavLink
                  style={navLinkStyle}
                  to="/dashboard/notifications"
                  className="flex gap-4 !justify-between hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                >
                  <ListItemButton className="flex gap-4 pl-0 !justify-between " sx={{ ...listItemButtonStyle, pl: 0, mt: 0 }}>
                    <Stack spacing={2} direction='row' >
                      <GoBell className="sidebar-icon" />
                      <span className="mr-4" >Notification</span>
                    </Stack>

                    <Chip

                      label="3"
                      size="small"
                      sx={{
                        background: '#EDF5FF',
                        color: '#1E87FF',
                        padding: '2px, 10px, 2px, 10px',
                        height: '19px',
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        fontWeight: 600,
                        lineHeight: '14.29px'
                      }}
                    />
                  </ListItemButton>
                </NavLink>
              </li>
              <Divider />

              <li className="mt-8 mb-8">
                <NavLink
                  style={navLinkStyle}
                  to="/dashboard/doc-signr"
                  className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                >
                  <ListItemButton className="flex gap-4 pl-0 !justify-between " sx={{ ...listItemButtonStyle, pl: 0, mt: 0 }}>
                    <Stack spacing={2} direction='row' >
                      <CiEdit className="sidebar-icon" />
                      <span>DocSignr</span>
                    </Stack>
                    <Chip

                      label="10"
                      size="small"
                      className="ml-4"
                      sx={{
                        background: '#EDF5FF',
                        color: '#1E87FF',
                        padding: '2px, 10px, 2px, 10px',
                        height: '19px',
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        fontWeight: 600,
                        lineHeight: '14.29px'
                      }}
                    />
                  </ListItemButton>
                </NavLink>
              </li>
            </ul>

            <ul>
              <Divider sx={{mb:5}} />
              <li className="mt-8 md:mt-0 mb-8">
                <NavLink
                  style={navLinkStyle}
                  to="/dashboard/settings"
                  className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                >
                  <LuSettings className="sidebar-icon" />
                  <span>Settings</span>
                </NavLink>
              </li>

              <li className="pb-8" onClick={handleOpenLogout}>
                <NavLink
                  style={navLinkStyle}
                  to="/dashboard/"
                  className="flex gap-4 items-center hover:text-[#1E87FF] text-[#292727] !font-sans text-sm leading-4 font-bold"
                >
                  <IoMdLogOut className="sidebar-icon" />
                  <span>Logout</span>
                </NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      {openLogout && (
        <LogoutModal
          handleLogout={handleActionLogout}
          onClose={handleCloseLogout}
        />
      )}
    </div>
  );
};

export default Sidebar;
